import { useTranslation } from 'react-i18next';

import { Namespace } from 'enums';

import styles from './HeaderMoreInfo.module.scss';

export const HeaderMoreInfo = () => {
  const { t } = useTranslation(Namespace.PersonalArea);

  return (
    <div className={styles.moreInfo}>
      {t('moreInformation')}{' '}
      <a
        target="_blank"
        href="https://engage.cloud.microsoft/main/org/itransition.com/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiI2OTMwMjE0OTEyMSJ9/all"
        rel="noreferrer"
      >
        {t('here')}
      </a>
    </div>
  );
};
